import React, { PureComponent, Fragment } from 'react'
import styles from './Header.scss'
import { scroller } from 'react-scroll'
import $ from 'jquery'

export default class Header extends PureComponent {
  state = {
    isCheckBurger: false,
  }

  _scrollToPlaceListTop = (section = '') => () => {
    if (typeof document !== 'undefined') {
      scroller.scrollTo(section, {
        duration: 600,
        delay: 0,
        smooth: 'easeOutCirc',
        isDynamic: true,
      })
      this.setState({
        isCheckBurger: false,
      })
    }
  }

  componentDidMount() {
    this.props.checkHeader()
    if (this.props.isApp) {
      this.header.style.top = '40px'
    }

    if ($(window).width() > 991) {
      setTimeout(function () {
        $('.menu').addClass('animated fadeInUp')
        $('.logo').addClass('animated fadeInUp')
      }, 300)
    }
    if ($(window).scrollTop() > 100) {
      this.header.classList.add('darkHeader')
      this.purple.classList.remove('show')
      this.white.classList.add('show')
    }
  }

  _onClickBurger = () => {
    if (this.state.isCheckBurger == false) {
      this.setState({
        isCheckBurger: true,
      })
    } else {
      this.setState({
        isCheckBurger: false,
      })
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.isCheckBurger) {
      this.mobMenu.style.display = 'block'
    } else {
      this.mobMenu.style.display = 'none'
      this.burgerCheck.checked = false
    }
    // if(!prevState.isVisableOurResource && this.state.isVisableOurResource) {
    //   this.ourResource.style.position = 'relative'
    //   this.ourResource.style.transform = 'translateY(0) scale(1)'
    //   this._boxEl.forEach(element => {
    //     element.style.transform = 'translateY(0)'
    //     element.style.opacity = '1'
    //   })
    //   this._boxNumberEl.forEach(element => {
    //     element.style.transform = 'translateY(0)'
    //     element.style.opacity = '1'
    //   })
    // }
  }

  _changeHeaderBackgroundInit = (currentPosition) => {
    if (currentPosition === 'below') {
      this.header.classList.remove('darkHeader')
      this.purple.classList.add('show')
      this.white.classList.remove('show')
    }
  }

  _changeHeaderBackgroundBlack = (previousPosition) => {
    if (previousPosition === 'below') {
      this.header.classList.add('darkHeader')
      this.purple.classList.remove('show')
      this.white.classList.add('show')
    }
  }
  render() {
    return (
      <Fragment>
        <style jsx>{styles}</style>

        <div ref={(el) => (this.header = el)} className="header animated fadeInUp">
          <div className="wrap">
            <div className="logo">
              <img
                src="/statics/images/creator/landingPage/poperLogoPurple.png"
                className="pc show"
                ref={(el) => (this.purple = el)}
              />
              <img
                src="/statics/images/creator/landingPage/poperLogoWhite.png"
                className="mob"
                ref={(el) => (this.white = el)}
              />
            </div>
            <div className="pcMenu menu">
              <span onClick={this._scrollToPlaceListTop('creatorResource')}>創作者資源</span>
              <span onClick={this._scrollToPlaceListTop('success')}>累積成就</span>
              <span onClick={this._scrollToPlaceListTop('exposureResource')}>曝光資源</span>
              <span onClick={this._scrollToPlaceListTop('creators')}>精選創作者</span>
            </div>
            <div onClick={this._onClickBurger} className="burger">
              <input ref={(el) => (this.burgerCheck = el)} type="checkbox" />
              <span />
              <span />
              <span />
            </div>
            <div ref={(el) => (this.mobMenu = el)} className="mobMenu menu">
              <div className="mask" />
              <span onClick={this._scrollToPlaceListTop('creatorResource')}>
                <p>創作者資源</p>
              </span>
              <span onClick={this._scrollToPlaceListTop('success')}>
                <p>累積成就</p>
              </span>
              <span onClick={this._scrollToPlaceListTop('exposureResource')}>
                <p>曝光資源</p>
              </span>
              <span onClick={this._scrollToPlaceListTop('creators')}>
                <p>精選創作者</p>
              </span>
            </div>
          </div>
        </div>
      </Fragment>
    )
  }
}
